import { render, staticRenderFns } from "./BasicBusinessInfo-Profile.vue?vue&type=template&id=40cb691a"
import script from "./BasicBusinessInfo-Profile.vue?vue&type=script&lang=js"
export * from "./BasicBusinessInfo-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports